import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { api, apiPublic } from '@/plugins/axios.js'
import { vue } from '@/main.js'

// Retorna os dados por equipe
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 */

export function formatOptionsProfissional(data) {
  const uniqueItems = new Set()
  const result = []

  data.forEach((item) => {
    const label = item.no_cbo.trim().split(' ')[0]
    const value = item.cbo_fam.trim()

    const uniqueKey = `${label}-${value}`

    if (!uniqueItems.has(uniqueKey)) {
      uniqueItems.add(uniqueKey)
      result.push({
        label: label,
        value: value,
      })
    }
  })

  return result
}

export async function getDadosData(cod_ibge) {
  try {
    const { data } = await api.get(`/app/agenda-por-profissional/${cod_ibge}`)
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna os dados por microárea
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 */

export function generatePdf(cadastros, selectEquipe, microArea) {
  let title_pdf = 'Agendamentos'
  let titlePdfSave = utils.methods.titlePdf(
    'Agendamentos',
    selectEquipe.no_equipe
  )

  let description_pdf = 'Cidadãos agendados para profissionais da APS'
  let headers_pdf = [
    'NOME',
    'NASCIMENTO',
    'MÃE',
    'AGENDADO PARA',
    'DATA E HORA',
  ]
  var data_pdf = []

  for (let i = 0; i < cadastros.length; i++) {
    let obj = {}
    obj.no_cidadao = cadastros[i].no_cidadao
    obj.dt_nascimento = utils.methods.formatDate(cadastros[i].dt_nascimento)
    obj.no_mae = cadastros[i].no_mae
    obj.no_profissional = cadastros[i].no_profissional
    obj.dt_hr_agendamento = `${utils.methods.formatDate(
      cadastros[i].dt_hr_agendamento.split(' ')[0]
    )} ${cadastros[i].dt_hr_agendamento.split(' ')[1]}`

    data_pdf.push(obj)
  }
  let doc = new jsPDF(utils.methods.encryptionPdf())
  // cria a tabela
  let table = utils.methods.createTablePdf(data_pdf)
  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64data) => {
      // Header
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64data,
        title_pdf,
        description_pdf
      )
      verticalPosition = utils.methods.bodyPdf(
        doc,
        [
          {
            label: 'Equipe',
            value: selectEquipe.no_equipe ?? selectEquipe.no_esf_eap,
          },
          {
            label: 'CNES',
            value: selectEquipe.nu_cnes,
          },
          {
            label: 'INE',
            value: selectEquipe.ine_esf_eap,
          },
          {
            label: 'Microárea',
            value: microArea,
          },
        ],
        verticalPosition
      )

      doc.autoTable({
        head: [headers_pdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: function (data) {
          if (data.row.section === 'head') {
            doc.setTextColor(0, 0, 0)
          }
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)

      doc.save(titlePdfSave + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}

export const dataFields = {
  Nome: 'no_cidadao',
  Nascimento: {
    field: 'dt_nascimento',
    callback: (value) => {
      return value !== null ? utils.methods.formatDate(value) : ''
    },
  },
  Mãe: 'no_mae',
  'Agendado para': 'no_profissional',
  'Data e hora': {
    field: 'dt_hr_agendamento',
    callback: (value) => {
      return value !== null
        ? `${utils.methods.formatDate(value.split(' ')[0])} ${
            value.split(' ')[1]
          }`
        : ''
    },
  },
}
